<div class="about-content">
<div class="main-title">
        <div class="container">
        <div class="headings">
            <h1>About Brand Ripplr</h1>
            <p>Brand Ripplr is the leading global talent agency and platform. Our proprietary AI platform and campaign management services enable brands to partner with 10M+ content creators and celebrities worldwide to deliver effective influencer campaigns.</p>
        </div>
        </div>
    </div>


<div class="container">
<div class="content">
    <div class="col align-items-center justify-content-center">
        <div>
            <h2>Our Mission</h2>
            <p>To be the region’s unrivalled leader of influencer marketing and ensure that brands partner with the right influencers to create engaging content that truly resonates with their target audiences and delivers results.</p>
            <br><br>
            <h2>What We Stand For</h2>
            <div class="list-items">
                <div class="item">
                    <strong>Deliver A World-Class Service</strong>
                    <p>We refuse to compromise on anything but excellent servicing for clients & influencers.</p>
                </div>
                <div class="item">
                    <strong>Technology Is Our Weapon</strong>
                    <p>We’re passionate about leveraging technology to revolutionise the process of influencer marketing.</p>
                </div>
                <div class="item">
                    <strong>Set The Trend</strong>
                    <p>We lead and educate the industry on the best way to produce impactful influencer marketing.</p>
                </div>
                <div class="item">
                    <strong>Empower Our People</strong>
                    <p>We invest in our people to cultivate an environment of continuous professional development and company growth.</p>
                </div>
                <div class="item">
                    <strong>Agility</strong>
                    <p>We strive for continuous incremental change - finding the smarter way of doing things.</p>
                </div>
            </div>

            <h2>Our Team Values</h2>
            <div class="list-items">
                <div class="item">
                    <strong>Find A Better Way</strong>
                    <p>We harness the collective creativity and entrepreneurial spirit of our team to always look for a better way, whether that’s delivering great client service or improving our platforms and services.</p>
                </div>
                <div class="item">
                    <strong>Build Something Great</strong>
                    <p>Our people work tirelessly to find answers that work for Brand Ripplr and our clients. Together with our clients, we are committed to building something great.</p>
                </div>
                <div class="item">
                    <strong>We Win Together</strong>
                    <p>We believe in a culture where our people ‘own’ the decisions that they take. Our differences strengthen us, lead to new ways of doing things and help us meet the needs of all our clients.</p>
                </div>
            </div>
        </div>
        <h2>Join Our Team</h2>
        <p >
            We are always looking for passionate and quality talent to strengthen our exciting and expanding team across the MENA region. Think you’d be a good fit? Check out our <a href="https://www.linkedin.com/company/brandripplr/" target="_blank">LinkedIn</a> page for opportunities.
        </p>
        
    </div>
</div>
</div>
</div>